export const paths = {
  any: '*',
  dashboard: '/dashboard',
  projects: {
    root: '/projects',
    new: '/projects/new',
    details: {
      root: '/projects/:projectId',
      tab: '/projects/:projectId/:tab',
    },
    children: {
      details: ':projectId',
    },
  },
  login: '/login',
} as const;
